module.exports = __webpack_public_path__ + "img/home_productthree.f3f88e15.jpg";